export const TICKET_CATEGORY = [
    {value: 1, label: "Cao nhất"},
    {value: 2, label: "Cao"},
    {value: 3, label: "Trung bình"},
    {value: 4, label: "Thấp"}
];
